import 'magnific-popup/dist/jquery.magnific-popup.min';

export function initLightbox() {
    $('.lightbox-item').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true,
        },
    });
}
